import { CloseIcon } from 'assets/icons/CloseIcon'
import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectAsyncInput } from 'components/HonestAsyncSelect/HonestAsyncSelectInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { ToggleButton } from 'components/Input/ToggleButton'
import { Modal } from 'components/Modal/Modal'
import { Button } from 'components/ui/Button/Button'
import { ISelectValue } from 'constants/globalTypes'
import { parseLocationRegistryOptions } from 'features/locationRegistry/locationRegistryMappers'
import useModalClose from 'hooks/useModalClose'
import { useState } from 'react'
import { CursorPointer, Flex } from 'styling/GlobalStyles'
import { TitleText } from 'styling/Typography'
import {
    IInventoryStockTakeCreateState,
    IStockTakeCreateModalProps,
} from 'types/inventoryControl.interface'
import useFocusFirstInput from 'utils/useFocusFirstInput'
import { STOCK_TAKE_CADENCE_OPTIONS } from '../Shared/inventoryFormatters'

export const StockTakeCreateModal = ({ closeModal, onCreate }: IStockTakeCreateModalProps) => {
    const [state, setState] = useState<IInventoryStockTakeCreateState>({
        name: '',
        location: null,
        scheduledDate: null,
        cadence: null,
        blind: true,
    })
    useFocusFirstInput()
    useModalClose(closeModal)

    const invalid = !state.name.trim() || !state.location?.value || !state.scheduledDate

    const handleSave = () => {
        if (invalid) return
        onCreate(state)
        closeModal()
    }

    return <Modal black>
        <Flex column between center>
            <Flex column gap='1rem' width='100%'>
                <Flex between width='100%' center style={{ marginBottom: '1rem' }}>
                    <TitleText weight='bold'>New stock take</TitleText>
                    <CursorPointer onClick={closeModal}>
                        <CloseIcon />
                    </CursorPointer>
                </Flex>
                <Input
                    placeholder='July cycle count — Main Warehouse'
                    labelText='Name'
                    value={state.name}
                    type='text'
                    name='name'
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setState({ ...state, name: e.target.value })}
                    nomarg
                    required
                    invalid={!state.name.trim()}
                />
                <HonestSelectAsyncInput
                    labelText='Location'
                    name='location'
                    link='locations'
                    defaultValue={state.location}
                    parserFunction={parseLocationRegistryOptions}
                    onChange={(value: ISelectValue) => setState({ ...state, location: value })}
                    nomarg
                    required
                    invalid={!state.location?.value}
                />
                <CalendarInput
                    labelText='Scheduled date'
                    name='scheduledDate'
                    defaultValue={state.scheduledDate}
                    minDate={new Date()}
                    onChange={(date: Date | null) => setState({ ...state, scheduledDate: date })}
                    nomarg
                    required
                />
                <HonestSelectInput
                    labelText='Cadence'
                    name='cadence'
                    options={STOCK_TAKE_CADENCE_OPTIONS}
                    defaultValue={state.cadence?.value}
                    onChange={(value: ISelectValue) => setState({ ...state, cadence: value })}
                    nomarg
                />
                <ToggleButton
                    start
                    label='Blind count'
                    state={state.blind}
                    handleChange={() => setState((prev) => ({ ...prev, blind: !prev.blind }))}
                />
            </Flex>
            <Button style={{ marginTop: '1rem' }} disabled={invalid} variant='primary' onClick={handleSave}>
                Save
            </Button>
        </Flex>
    </Modal>
}
